import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import RankedTable from "../layout/RankedTable";

const PAGE_SIZE = 15;

const RoleManagementTable = ({
  searchText,
  setSearchText,
  filteredRoles,
  onEditRole,
  onDeleteRole,
  deleteLoadingId,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  const pageCount = Math.ceil(filteredRoles.length / PAGE_SIZE);
  const currentData = filteredRoles.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE);

  const handleSearch = (e) => { setSearchText(e.target.value); setCurrentPage(0); };

  return (
    <div className="pb-2">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-3 px-1">
        <div className="flex items-center gap-3">
          <input
            type="text"
            className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
            style={{ minWidth: "280px" }}
            placeholder="Search by role name"
            value={searchText}
            onChange={handleSearch}
          />
         
        </div>
        {pageCount > 1 && (
          <ReactPaginate
            previousLabel={"‹"} nextLabel={"›"} breakLabel={"..."}
            pageCount={pageCount} marginPagesDisplayed={1} pageRangeDisplayed={3}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            forcePage={currentPage}
            containerClassName={"pagination"} pageClassName={"page-item"} pageLinkClassName={"page-link"}
            previousClassName={"page-item"} previousLinkClassName={"page-link"}
            nextClassName={"page-item"} nextLinkClassName={"page-link"}
            breakClassName={"page-item"} breakLinkClassName={"page-link"} activeClassName={"active"}
          />
        )}
      </div>

      <RankedTable
        columns={[{ label: "Role Name" }, { label: "Created By" }, { label: "Created At" }, { label: "Actions", align: "center" }]}
        rows={currentData}
        emptyText="No matching roles found."
        renderRow={(role) => (<>
          <td className="px-5 py-3 font-medium text-gray-800 text-xs">{role.name}</td>
          <td className="px-5 py-3 text-gray-500 text-xs">{role.createdBy}</td>
          <td className="px-5 py-3 text-gray-400 text-xs">{role.createdAt}</td>
          <td className="px-5 py-3 text-center">
            <div className="flex items-center justify-center gap-2">
              <button
                type="button"
                style={{ padding: "4px 12px", borderRadius: "6px", border: "1px solid #bfdbfe", background: "#eff6ff", cursor: "pointer", color: "#1d4ed8", fontSize: "11px", fontWeight: 600 }}
                onMouseEnter={e => e.currentTarget.style.background = "#dbeafe"}
                onMouseLeave={e => e.currentTarget.style.background = "#eff6ff"}
                onClick={() => onEditRole(role)}
              >Edit</button>
              <button
                type="button"
                style={{ padding: "4px 12px", borderRadius: "6px", border: "1px solid #fecaca", background: "#fff5f5", cursor: "pointer", color: "#dc2626", fontSize: "11px", fontWeight: 600 }}
                onMouseEnter={e => e.currentTarget.style.background = "#fee2e2"}
                onMouseLeave={e => e.currentTarget.style.background = "#fff5f5"}
                disabled={deleteLoadingId === role.id}
                onClick={() => onDeleteRole(role.id)}
              >{deleteLoadingId === role.id ? "Deleting..." : "Delete"}</button>
            </div>
          </td>
        </>)}
      />
    </div>
  );
};

export default RoleManagementTable;
